export const DEFAULT_TITLE = 'Growexa';

export const MAX_DATE = '2099-12-31';
